import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import { Dialog, DialogActions, DialogContent, Button, Card, CardMedia, Typography, CardContent, Box, Grid, CircularProgress } from '@mui/material';
import { ArrowForward, ArrowBack } from '@mui/icons-material';
import ReactPlayer from 'react-player';
import { useContent } from '../../../../context/ContentContext';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';

const MediaCarousel = () => {
    const { banner, fetchBannerData, loading } = useContent(); // Get banner and fetchBannerData from context
    const [openDialog, setOpenDialog] = useState(false); // To open/close the dialog
    const [currentMedia, setCurrentMedia] = useState(null); // To store the media URL for the dialog
    const [mediaType, setMediaType] = useState(''); // To track whether it's an image or video
    const [currentTitle, setCurrentTitle] = useState(''); // To store the title for the dialog
    const [currentDescription, setCurrentDescription] = useState(''); // To store the description for the dialog

    useEffect(() => {
        if (!banner.length) {
            fetchBannerData(); // Fetch banner data if it's not already available
        }
    }, [banner, fetchBannerData]);

    const handleDialogOpen = (item) => {
        setCurrentMedia(item.file);
        setCurrentTitle(item.title); // Store the title
        setCurrentDescription(item.description); // Store the description
        const type = item.file.endsWith('.mp4') ? 'video' : 'image';
        console.log(type); // Check if mediaType is being detected correctly
        setMediaType(type);
        setOpenDialog(true);
    };

    const handleDialogClose = () => {
        setOpenDialog(false);
    };

    const CustomNextArrow = (props) => {
        const { className, style, onClick } = props; // Extract only relevant props
        return (
            <div
                className={className}
                style={{ ...style, display: 'block', color: 'black', fontSize: '32px' }}
                onClick={onClick}
            >
                <ArrowForward />
            </div>
        );
    };

    const CustomPrevArrow = (props) => {
        const { className, style, onClick } = props; // Extract only relevant props
        return (
            <div
                className={className}
                style={{ ...style, display: 'block', color: 'black', fontSize: '24px' }}
                onClick={onClick}
            >
                <ArrowBack />
            </div>
        );
    };


    const settings = {
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    useEffect(() => {
        console.log(banner); // Check if 'banner' is loaded
    }, [banner]);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Box sx={{ position: 'relative', overflow: 'hidden', maxWidth: '900px', height: '100%' }}>
                {/* Loading spinner */}
                {loading ? (
                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Slider {...settings}>
                        {banner.map(({ file, title, description }, index) => {
                            const isVideo = file.endsWith('.mp4');
                            return (
                                <Card
                                    key={index}
                                    onClick={() => handleDialogOpen({ file, title, description })}
                                    sx={{
                                        position: 'relative',
                                        cursor: 'pointer',
                                        height: '100%',
                                        width: '100%',
                                        maxWidth: 400,
                                        padding: 0,
                                    }}
                                >
                                    <CardActionArea sx={{ position: 'relative', paddingTop: '56.25%', height: 0, overflow: 'hidden' }}>
                                        {isVideo ? (
                                            <ReactPlayer
                                                url={file}
                                                controls={false}
                                                width="100%"
                                                height="100%"
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                }}
                                            />
                                        ) : (
                                            <CardMedia
                                                component="img"
                                                image={file}
                                                alt={title}
                                                sx={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover',
                                                    padding: 0,
                                                }}
                                            />
                                        )}
                                        <CardContent
                                            sx={{
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                right: 0,
                                                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                                color: 'white',
                                                width: '100%',
                                                px: '10px',
                                            }}
                                        >
                                            <Typography variant="h6" sx={{ color: 'white' }}>
                                                {title}
                                            </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                    <CardActions sx={{ padding: 1 }}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: 'black',
                                                whiteSpace: 'normal',
                                                wordWrap: 'break-word',
                                                overflowWrap: 'break-word',
                                            }}
                                        >
                                            {description}
                                        </Typography>
                                    </CardActions>
                                </Card>
                            );
                        })}
                    </Slider>
                )}

                {/* Dialog for full media */}
                <Dialog open={openDialog} onClose={handleDialogClose}>
                    <DialogContent>
                        {/* Display title and description in the dialog */}
                        <Typography variant="h6" sx={{ color: 'black', marginBottom: '10px' }}>
                            {currentTitle}
                        </Typography>
                        {mediaType === 'image' ? (
                            <img src={currentMedia} alt="Media" style={{ width: '100%', height: 'auto' }} />
                        ) : (
                            <video src={currentMedia} controls autoPlay style={{ width: '100%', height: 'auto' }} />
                        )}
                        <Typography variant="body2" sx={{ color: 'black', marginBottom: '20px' }}>
                            {currentDescription}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleDialogClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Box>
    );
};

export default MediaCarousel;
